var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-tools cw-tools-contents",
    },
    [
      _c(
        _vm.headerComponent,
        {
          tag: "component",
          class: {
            "root-is-current": _vm.rootIsCurrent,
            "root-is-hidden": _vm.hideRoot,
          },
          attrs: {
            to: "/structural_element/" + _vm.rootElement.id,
          },
        },
        [
          _vm.rootElement
            ? _c(
                "div",
                {
                  staticClass: "cw-tools-contents-header",
                },
                [
                  _c("studip-ident-image", {
                    attrs: {
                      baseColor: _vm.headerColor.hex,
                      pattern: _vm.rootElement.attributes.title,
                    },
                    model: {
                      value: _vm.identimage,
                      callback: function callback($$v) {
                        _vm.identimage = $$v
                      },
                      expression: "identimage",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "cw-tools-contents-header-image",
                    style: _vm.headerImageStyle,
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cw-tools-contents-header-details",
                    },
                    [
                      _c("header", [
                        _vm._v(_vm._s(_vm.rootElement.attributes.title)),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.rootElement.attributes.payload.description)
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.structuralElements.length ? _c("courseware-tree") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }